import { ReactNode } from 'react'
import { Tooltip, Text, Button } from '@/ui'
import { TypographyStyles } from '@/styles'
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons'
export const DetailsTooltip = ({
  label,
  children,
  track,
  openOnHover,
}: {
  label: string | ReactNode
  children: ReactNode
  track?: () => void
  openOnHover?: boolean
}) => {
  return (
    <Tooltip
      onOpenChange={() => track?.()}
      delayDuration={openOnHover ? 0 : 999999}
    >
      <Tooltip.Trigger asChild>
        <Button variant="discreet" iconLeft={faQuestionCircle} />
      </Tooltip.Trigger>
      <Tooltip.Content side="top" align="center">
        <div className="flex flex-col max-w-full sm:max-w-[200px]">
          <Text variant={TypographyStyles.LABEL_MD} className="mb-2 w-full">
            {label}
          </Text>
          {children}
        </div>
      </Tooltip.Content>
    </Tooltip>
  )
}
